import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "16",
  viewBox: "0 0 14 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.76001 6.2092L11.0462 8.0092L7.76001 9.8092L5.96001 13.0954L4.16001 9.8092L0.864624 8.0092L4.16001 6.2092L5.96001 2.91382L7.76001 6.2092Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.3108 2.65539L13.9816 3.56923L12.3108 4.48308L11.3969 6.16308L10.4831 4.48308L8.8031 3.56923L10.4831 2.65539L11.3969 0.984619L12.3108 2.65539Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.3108 11.5169L13.9816 12.4308L12.3108 13.3446L11.3969 15.0154L10.4831 13.3446L8.8031 12.4308L10.4831 11.5169L11.3969 9.83691L12.3108 11.5169Z",
  fill: "currentColor"
})), 'StarGroup', {
  viewBox: '0 0 14 16'
});